import React, { lazy, Suspense } from 'react';
import './../packs/i18n';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('react-devise');
const Devise = lazy(() => import('../pages/Devise'));

if (container) {
  const root = createRoot(container);

  document.addEventListener('DOMContentLoaded', () => {
    root.render(
      <Suspense>
        <Devise />
      </Suspense>
    );
  });
}
